<template>
	<div class="articleList table-responsive">
		<table>
			<thead>
				<tr>
					<th>
						<div class="flex start flex-nowrap">
							<span class="th">Name</span>
							<div class="ml-auto">
								<form :action="endPoint" method="GET" ref="NameSort">
									<input name="filter" type="hidden" v-model="urlParams.filter">
									<input name="sort" type="hidden" v-if="urlParams.sort === 'desc-first_name'"
										   value="asc-first_name">
									<input name="sort" type="hidden" v-else value="desc-first_name">

									<i @click="sortTable('NameSort')" class="fas fa-sort-alpha-up"
									   v-if="urlParams.sort === 'desc-first_name'"></i>
									<i @click="sortTable('NameSort')" class="fas fa-sort-alpha-down" v-else></i>
								</form>
							</div>
						</div>
					</th>
					<th>
						<div class="flex start flex-nowrap">
							<span class="th">Email Address</span>
							<div class="ml-auto">
								<form :action="endPoint" method="GET" ref="EmailSort">
									<input name="filter" type="hidden" v-model="urlParams.filter">
									<input name="sort" type="hidden" v-if="urlParams.sort === 'desc-email'"
										   value="asc-email">
									<input name="sort" type="hidden" v-else value="desc-email">

									<i @click="sortTable('EmailSort')" class="fas fa-sort-alpha-up"
									   v-if="urlParams.sort === 'desc-email'"></i>
									<i @click="sortTable('EmailSort')" class="fas fa-sort-alpha-down" v-else></i>
								</form>
							</div>
						</div>
					</th>
					<th>
						<div class="flex start flex-nowrap">
							<span class="th">Last Updated</span>
							<div class="ml-auto">
								<form :action="endPoint" method="GET" ref="DateSort">
									<input name="filter" type="hidden" v-model="urlParams.filter">
									<input name="sort" type="hidden" v-if="urlParams.sort === 'desc-updated_at'"
										   value="asc-updated_at">
									<input name="sort" type="hidden" v-else value="desc-updated_at">

									<i @click="sortTable('DateSort')" class="fas fa-sort-alpha-up"
									   v-if="urlParams.sort === 'desc-updated_at'"></i>
									<i @click="sortTable('DateSort')" class="fas fa-sort-alpha-down" v-else></i>
								</form>
							</div>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<pp-user-item :data-user="item"
							  :key="item.id"
							  v-for="item in userList"
				></pp-user-item>
			</tbody>
		</table>
	</div>
</template>

<script>
	export default {
		props: {
			dataUserList: {
				type: Array,
			},
			dataEndpoint: {
				type: String
			},
			dataUrlParams: {
				type: Object,
				required: false
			},
		},
		data() {
			return {
				userList: this.dataUserList,
				endPoint: this.dataEndpoint,
				urlParams: this.dataUrlParams || [],
			}
		},
		methods: {
			sortTable: function (form) {
				$('input, select').each(function (_, inp) {
					if ($(inp).val() === '' || $(inp).val() === null)
						inp.disabled = true;
				});
				this.$refs[form].submit();
			}
		}
	}
</script>
